'use strict';
export default class Product {
  constructor() {
    this.initSlider();
    try {
      this.hideDuplicateProduct();
    } catch(e) {
      
    }
  }

  initSlider() {
    var slider = $('.product_type_brochure .field--name-field-image');
    var slideNav = slider.clone();
    slider.addClass('main-slider');
    slideNav.addClass('slider-nav');
    slider.after(slideNav);

    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.slider-nav'
    });

    slideNav.slick({
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.main-slider',
      dots: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    slideNav.on('click', '.field__item', function (e) {
      var slideno = $(this).data('slick-index');
      slideNav.slick('slickGoTo', slideno);
    })
  }

  hideDuplicateProduct() {
    // remove duplicate product from related product block
    var block = $(".view-id-products_blocks");
    var ids = [];
    $.each(block.find('.product-card-wrapper'), function (k, v) {
      if (ids.includes($(v).data('id'))) {
        $(v).closest('.views-row').remove();
      } else {
        ids.push($(v).data('id'));
      }
    });
  }
}
